import { useState } from 'react';
import { FilterOutlined, LoadingOutlined } from '@ant-design/icons';
import { Modal, Form, DatePicker, InputNumber, Col, Row } from 'antd';
import '../query.css';
import { Tooltip } from 'antd';
import { Button } from 'react-bootstrap';
import FilterModalItsDataFetch from './FilterModalItsDataFetch';
import FilterModalItsYearSelect from './FilterModalItsYearSelect';
import { ITS_FIELD_LABELS } from '../../util/ITS';

const { RangePicker } = DatePicker;

const FilterModalIts = (props) => {
  const [hover, toggleHover] = useState();
  const [visible, setVisible] = useState();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const [notUsedCols] = useState([
    'geom',
    'wkb_geometry',
    'objectid',
    'shape_length',
    'shape_area',
    'aland',
    'awater',
    'website',
    'lastupdated',
    'name',
    'acres',
    'statefp',
    'intptlat',
    'intptlon',
    'countyfp',
    'countyns',
    'geoid',
    'lsad',
    'classfp',
    'mtfcc',
    'csafp',
    'cbsafp',
    'metdivfp',
    'funcstat',
    'macsid',
    'notes',
    'address',
    'phone',
    'activity_end',
    'activity_uom',
    'fid_spaghetti2020',
    'footprintacres',
    'point_count',
    'polygonarea',
    'activity_quantity',
    'activity_description',
    'broad_vegetation_type',
    'activity_status',
    'activity_uom',
    'activity_end',
    'geom',
    'wui',
    // 'agency',
    'entity_type',
    // Removed geo filters for users to use visualization filtering on map view
    'county',
    'region',
  ]);

  const numberType = [
    'int',
    'double',
    'integer',
    'number',
    'esrifieldtypedouble',
  ];

  const translateWmsToGeneralFields = (fields) => {
    let final = [];
    fields.forEach((e) => {
      final.push({
        name: e.name,
        type: e.localType,
        label: e.name,
        coded_values:
          e.coded_values != undefined && e.coded_values.length > 0
            ? e.coded_values.map((item) => {
                return {
                  value: item,
                  label: item,
                };
              })
            : undefined,
      });
    });
    return final;
  };

  const getSetFilterOptions = async (gis_service, key) => {
    //get attribute table
    let url = `${gis_service.service_url}?SERVICE=WFS&version=1.3.0&request=DescribeFeatureType&typeNames=${gis_service.layer_name}&outputFormat=application/json`;
    let response = await fetch(url);
    let data = await response.json();
    let features = data.featureTypes[0].properties;
    let complete_features = [];
    const promises = features
      .filter((e) => !notUsedCols.includes(e.name)) // Filter features before processing
      .filter((e) => !numberType.includes(e.type.toLowerCase())); // Filter by type

    // Wait for all promises to resolve
    const results = promises;
    complete_features.push(...results);

    let filterItems = { ...props.filterItems };
    let prevFilter = filterItems[key];

    let fields = translateWmsToGeneralFields(complete_features);
    let options = createOptions(fields, prevFilter);

    let filter_options = { ...props.filter_options };
    filter_options[key] = options;
    props.setFilterOptions(filter_options);
  };

  const createOptions = (fields, prevFilter) => {
    let final = [];
    fields.forEach((e) => {
      // if the field is a number, add min and max values for range
      if (numberType.includes(e.type.toLowerCase())) {
        final.push({
          name: e.name + '_min',
          type: e.type,
          label: e.label,
          placeholder: 'Start Value',
          value:
            prevFilter !== undefined && prevFilter[e.name] !== undefined
              ? prevFilter[e.name][0]
              : undefined,
          // coded_values: e.coded_values
          coded_values: undefined,
        });

        final.push({
          name: e.name + '_max',
          type: e.type,
          label: '</br>',
          placeholder: 'End Value',
          value:
            prevFilter !== undefined && prevFilter[e.name] !== undefined
              ? prevFilter[e.name][1]
              : undefined,
          coded_values: undefined,
          // coded_values: e.coded_values
        });
      } else {
        final.push({
          name: e.name,
          type: e.type,
          label: e.label,
          value:
            prevFilter !== undefined && prevFilter[e.name] !== undefined
              ? prevFilter[e.name]
              : undefined,
          coded_values: e.coded_values,
        });
      }
    });
    return final;
  };

  const showModal = async () => {
    setVisible(true);
    setLoading(true);

    let gis_service = props.getGisService(props.item);
    let key = props.getItemKey(props.item);
    await getSetFilterOptions(gis_service, key);

    setLoading(false);
  };

  const saveFilter = () => {
    const values = form.getFieldsValue(true);
    let key = props.getItemKey(props.item);

    //filter for double variables are in two seperate fields (name_min, name_max), they need to be brought together
    props.filter_options[key]
      .filter((e) => {
        return (
          numberType.includes(e.type.toLowerCase()) &&
          values[e.name] !== undefined &&
          !e.type.includes('esriFieldTypeDouble')
        );
      })
      .forEach((e) => {
        let is_min = e.name.endsWith('_min') ? true : false;
        let original_name = e.name.slice(0, -4);

        if (original_name in values === false) {
          values[original_name] = [0, 0];
        }

        values[original_name][is_min ? 0 : 1] = Number(values[e.name]);

        delete values[e.name];
      });

    let itemKey = props.getItemKey(props.item);
    let filterItems = { ...props.filterItems };
    filterItems[itemKey] = values;
    props.setFilterItems(filterItems);

    setVisible(false);
  };

  let rootStyle = props.style;
  if (rootStyle === undefined) {
    rootStyle = {
      position: 'absolute',
      // top: '196px',
      // left: '7px',
      padding: '1px 4px 1px 4px',
      borderRadius: '6px',
      backgroundColor: hover ? '#3D5249' : '#2C3E37',
      border: '3px solid rgba(255, 255, 255, 0.72)',
    };
  }

  const getLabel = (label) => {
    return ITS_FIELD_LABELS[label] ? ITS_FIELD_LABELS[label] : label;
  };

  let itemKey = props.getItemKey(props.item);

  return (
    <div key={itemKey}>
      {/* {Object.keys(props.filter_options).includes(itemKey) ? */}
      <div>
        <div
          style={rootStyle}
          onMouseEnter={() => toggleHover(true)}
          onMouseLeave={() => toggleHover(false)}
        >
          <Tooltip title={'Filter Map'} placement="top">
            <FilterOutlined onClick={showModal} style={{ color: 'white' }} />
          </Tooltip>
        </div>
        {/* TODO fix name display for ckan data */}
        <Modal
          forceRender
          title={'Filter - ' + props.item.title}
          open={visible}
          onCancel={() => setVisible(false)}
          destroyOnHidden={true}
          footer={null}
          width={800}
        >
          {loading ? (
            <div style={{ textAlign: 'center' }}>
              <LoadingOutlined></LoadingOutlined> Loading Filters
            </div>
          ) : (
            <div>
              <Form
                form={form}
                name={'filter_modal_its' + props.item.title}
                layout="vertical"
                onFinish={saveFilter}
                preserve={true}
                autoComplete="off"
                fields={props.filter_options[itemKey]}
                scrollToFirstError="true"
              >
                <Row>
                  {Object.keys(props.filter_options).includes(itemKey)
                    ? props.filter_options[itemKey].map((option, i) => {
                        if (numberType.includes(option.type.toLowerCase())) {
                          return (
                            <Col
                              key={props?.item?.name + i}
                              span={6}
                              style={{ paddingRight: 20 }}
                            >
                              <Row>
                                <Col span={24} style={{ paddingBottom: 8 }}>
                                  {
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: getLabel(option.label),
                                      }}
                                    ></span>
                                  }
                                </Col>
                                <Col span={24}>
                                  <Form.Item name={option.name + i}>
                                    <InputNumber
                                      style={{ width: '90%' }}
                                      placeholder={option.placeholder}
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Col>
                          );
                        } else if (option.type.toLowerCase().includes('date')) {
                          return (
                            <Col
                              key={props?.item?.name + i}
                              span={12}
                              style={{ paddingRight: 20 }}
                            >
                              <Form.Item
                                name={option.name + i}
                                label={
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: getLabel(option.label),
                                    }}
                                  ></span>
                                }
                              >
                                <RangePicker />
                              </Form.Item>
                            </Col>
                          );
                        } else {
                          if (option.name.includes('year_txt')) {
                            return (
                              <Col
                                key={props?.item?.name + i}
                                span={12}
                                style={{ paddingRight: 20, paddingBottom: 8 }}
                              >
                                <FilterModalItsYearSelect
                                  option={option}
                                  gis_service={props.getGisService(props.item)}
                                  itemKey={itemKey}
                                  form={form}
                                  i={i}
                                  setFieldValue={form.setFieldValue}
                                />
                              </Col>
                            );
                          } else {
                            return (
                              <Col
                                key={props?.item?.name + i}
                                span={12}
                                style={{ paddingRight: 20, paddingBottom: 8 }}
                              >
                                <FilterModalItsDataFetch
                                  option={option}
                                  gis_service={props.getGisService(props.item)}
                                  itemKey={itemKey}
                                  form={form}
                                  i={i}
                                  setFieldValue={form.setFieldValue}
                                />
                              </Col>
                            );
                          }
                        }
                      })
                    : []}
                </Row>
                {Object.keys(props.filter_options).includes(itemKey) ? (
                  <div>
                    <Col span={24}>
                      <div style={{ fontSize: 10 }}>
                        *All fields are disabled prior to options are loaded.
                        Please wait.
                      </div>
                    </Col>
                    <Col
                      span={24}
                      align="end"
                      style={{ marginTop: 10, marginBottom: 10 }}
                    >
                      <Button
                        type="primary"
                        // htmlType="submit"
                        className="btn_primary"
                      >
                        Filter
                      </Button>
                    </Col>
                  </div>
                ) : (
                  <div style={{ textAlign: 'center' }}>
                    Filter is unavailable for this dataset
                  </div>
                )}
              </Form>
            </div>
          )}
        </Modal>
      </div>
    </div>
  );
};

export default FilterModalIts;
